module.exports = __webpack_public_path__ + "static/media/oberflex-zebranochocolat-2560x1440.2ab02962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranochocolat-2560x1440.jpg
// module id = 1079
// module chunks = 37